import { render, staticRenderFns } from "./WidgetDocumentsByCreationDateByPath.vue?vue&type=template&id=3285ee52&"
import script from "./WidgetDocumentsByCreationDateByPath.vue?vue&type=script&lang=js&"
export * from "./WidgetDocumentsByCreationDateByPath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports